/**
 * Possible types of Status Indicator AUI component
 */
export enum StatusIndicatorType {
    Loading = "loading",
    Success = "success",
    Error = "error",
}